export const tablet = `@media(min-width: 720px)`
export const desktop = `@media(min-width: 1024px)`
export const desktopXL = `@media(min-width: 1280px)`
